export default "__VITE_ASSET__f9_sK921__"